export const CONSUMPTION_POINT_LIST_FETCH = 'CONSUMPTION_POINT_LIST_FETCH';
